import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute, RenderComponent } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { redirects } from '@lib/redirects';
import { Route } from '@packages/router';
import React from 'react';
import { TABS } from './List/Views/Customer/tabs';

export const routes$ = {
    ListCustomer: AsyncPageRender(() => pageModule(import('./List'))),
    Invoice: AsyncPageRender(() => pageModule(import('./Invoice'))),
    Pay: AsyncPageRender(() => pageModule(import('./Pay'))),
    TipDesigner: AsyncPageRender(() => pageModule(import('./TipDesigner'))),
};

export default Router;

function Router() {
    return (
        <>
            {redirects({
                '/orders': `/order/${TABS[0]}/list`,
            })}
            <Route
                name={'Order.List'}
                exact
                path={'/order/:tab/list'}
                component={ProtectedRoute(routes$.ListCustomer)}
            />
            <Route
                name={'Order.Invoice'}
                exact
                path={'/order/invoice/:orderId'}
                component={ProtectedRoute(routes$.Invoice, { required: null })}
            />
            <Route
                name={'Order.Pay'}
                exact
                path={'/order/pay/:orderId'}
                component={RenderComponent(routes$.Pay, true)}
            />
            <Route
                name={'Order.Tip.Designer'}
                exact
                path={'/order/:orderId/tip-designer'}
                component={ProtectedRoute(routes$.TipDesigner)}
            />
        </>
    );
}
